module.exports = "/assets/0604db0f05c95ac5b9317e189df7ef25.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AD.png
// module id = 2320
// module chunks = 0